// Download only the signed URL returned by getFile; do not attach API auth headers.
export async function fetchReportPdf(url, { signal } = {}) {
  const response = await fetch(url, { signal });
  if (!response.ok) throw new Error(`PDF download failed (HTTP ${response.status}). Refresh the PDF link and try again.`);
  const blob = await response.blob();
  const header = await blob.slice(0, 1024).text();
  if (!header.includes('%PDF-')) {
    throw new Error('The file response is not a PDF. Refresh the PDF link and try again.');
  }
  return new Blob([blob], { type: 'application/pdf' });
}